module.exports = __webpack_public_path__ + "static/img/cloud-bg-2.4065710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error/cloud-bg-2.png
// module id = q/eM
// module chunks = 0